import * as yup from 'yup';
import { AddEdgeSvg } from '../../../../assets';
import {
    regExIdentifiers,
    reservedKeywords,
    validationMessages,
} from '../../../../constants';
import { validationsMessages as globalValidationMessages } from 'lib';
import { EdgeDefinition, themeObject } from '../../../../lib';
import { AttributeAssociationItem } from '../../edge-definition-helper';

export interface AttributeAssociationSelectionProps {
    isFirstItem: boolean;
    leftSideSelectionOptions: string[];
    rightSideSelectionOptions: string[];
    handleRemove: () => void;
    attributeAssociationItem: AttributeAssociationItem;
    onAttributeAssociationChanged: (
        associationItem: AttributeAssociationItem
    ) => void;
}

export interface AttributeAssociationWidgetProps {
    attributeAssociationList: AttributeAssociationItem[];
    leftSideSelectionOptions: string[];
    rightSideSelectionOptions: string[];
    handleAttributeAssociationsChanged: (
        list: AttributeAssociationItem[]
    ) => void;
}

export const edgeSchema: yup.SchemaOf<EdgeDefinition> = yup.object({
    name: yup
        .string()
        .required(globalValidationMessages.required)
        .matches(regExIdentifiers.name, validationMessages.invalidName)
        .notOneOf(reservedKeywords, validationMessages.reservedWord),
    fromDictionary: yup.string().required(globalValidationMessages.required),
    toDictionary: yup.string().required(globalValidationMessages.required),
    condition: yup
        .array()
        .of(
            yup.object({
                fromCol: yup.string().required(),
                toCol: yup.string().required(),
            })
        )
        .required(),
});

export const edgeDefinitionConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    edges: {
        imgSrc: AddEdgeSvg,
        headingText: 'New Edge Definition',
        iconStyles: {
            width: '90px',
            height: '79.23px',
        },
    },
};

export const createEdgeDefinitionStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 3,
        mx: '143.5px',
    },
    textFieldContainer: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    dictionariesContainer: {
        mt: 1.5,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    fromDictionaryTextField: {
        width: '100%',
        mr: 2.5,
    },
    formLabelContainer: {
        mb: '3px',
    },
    dictionaryTextField: {
        width: '100%',
    },
    dictionaryAutocomplete: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '278.5px',
        },
    },
    nameTextField: {
        width: '100%',
    },
    attributeAssociationContainer: {
        mt: 2,
        width: '100%',
    },
};

export const attributeAssociationSelectionStyles = {
    attributeAssociationSelectionContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 2,
    },
    associationAutocomplete: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '278.5px',
        },
    },
    nonFirstLeftAssociationAutocomplete: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '278px',
        },
    },
    nonFirstItemRightSideAssociationAutocomplete: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '247px',
        },
    },
    associationLeftSideContainer: {
        width: '100%',
    },
    associationRightSideContainer: {
        width: '100%',
        ml: 2.5,
    },
    nonFirstItemAssociationRightSideContainer: {
        width: '100%',
        ml: 2.5625,
    },
    deleteAssociationButtonContainer: {
        width: '100%',
        height: '100%',
        mt: 3.5,
        ml: 1.5,
    },
    deleteButton: {
        width: '20px',
        height: '20px',
        mt: 1,
        backgroundColor: themeObject.palette.grayScale[500],
        color: themeObject.palette.background.default,
    },
};

export const attributeAssociationWidgetStyles = {
    listContainer: {
        width: '100%',
    },
    titleContainer: {
        width: '100%',
        mb: 2,
    },
    attributeAssociationTitle: {
        ...themeObject.typography.h4,
        color: themeObject.palette.primary[700],
    },
    list: {
        width: '100%',
        pt: 0,
        pb: 0,
    },
    addButtonContainer: {
        width: '100%',
    },
    addButton: {
        borderRadius: '20px',
        width: '249px',
        height: '40.25px',
        '& .MuiTypography-root': {
            ...themeObject.components.MuiButton.styleOverrides.root,
            ...themeObject.components.MuiButton.styleOverrides.medium,
            color: themeObject.palette.grayScale[700],
            ml: '3px',
        },
    },
};
